import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyABpLD20yD9szXYMZhlnsY_z6ebh7B4F70",
  authDomain: "photo-fun-live.firebaseapp.com",
  projectId: "photo-fun-live",
  storageBucket: "photo-fun-live.firebasestorage.app",
  messagingSenderId: "74389946474",
  appId: "1:74389946474:web:cb42196fd43edd98a20a13",
};

export const app = initializeApp(firebaseConfig);

// App Check, monitor-first (Oct 23, 2026): the reCAPTCHA Enterprise site key
// is public by design; an empty key keeps this inert until the PhotoFun Web
// app is registered in Firebase App Check. Enforcement of any API needs this
// live first (CLAUDE.md, App Check). On a localhost dev server reCAPTCHA cannot pass,
// so the SDK's debug token is used; register it once under Manage debug
// tokens when it prints in the browser console.
const APP_CHECK_SITE_KEY = "6LfIbP0tAAAAABBc4PiPG5x_eVU_70Bp2KjAI-6P";
if (APP_CHECK_SITE_KEY) {
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(APP_CHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
  } catch {
    // No token, like today.
  }
}
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
